// TODO (LEMS-3815): Remove this file
const styles = {
    tooltipBody: {
        color: "var(--wb-semanticColor-core-foreground-neutral-strong)",
        fontSize: "var(--wb-font-body-size-medium)",
        fontWeight: "var(--wb-font-weight-medium)",
        lineHeight: "var(--wb-font-body-lineHeight-medium)",
    },
};

export default styles;
